import React from 'react';
import { Table, Button, message } from 'antd';
import { connect } from 'dva';
import _cloneDeep from 'lodash/cloneDeep';
import { handleData } from './util.js';
import EditableCell from './EditableCell/Index.js';
import EditModal from '../EditModal.js';
import styles from './Index.less';

@connect(() => ({}))
export default class SkusTable extends React.Component {
  constructor(props) {
    super(props);

    const { columns, dataSource } = handleData(props.skusList, props.combinationList);
    this.state = {
      modalVisible: false,
      columns,
      dataSource,
    };

    this.onCellChange = this.onCellChange.bind(this);
    this.handleSetPrice = this.handleSetPrice.bind(this);
    this.handleModalOk = this.handleModalOk.bind(this);
    this.handleModalCancel = this.handleModalCancel.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { columns, dataSource } = handleData(nextProps.skusList, nextProps.combinationList);
    this.setState({ columns, dataSource });
  }

  onCellChange(key, props) {
    return value => {
      const dataSource = [...this.state.dataSource];
      const target = dataSource.find(item => item.key === key);

      if (target) {
        target[props] = value;
        this.props.dispatch({
          type: 'SkusEdit/updateCombinationList',
          dataSource,
        });
      }
    };
  }

  handleSetPrice() {
    this.setState({ modalVisible: true });
  }

  handleModalOk(value) {
    const { lowPrice, highPrice } = this.props;
    const price = Number(value);
    const dataSource = _cloneDeep(this.state.dataSource);

    if (Number.isNaN(price)) {
      return message.warning('请输入合法的金额');
    }

    if (price < lowPrice || price > highPrice) {
      return message.warning(`价格区间为${lowPrice}~${highPrice}元`);
    }

    dataSource.forEach(item => {
      item.price = price; // eslint-disable-line
    });

    this.props.dispatch({
      type: 'SkusEdit/updateCombinationList',
      dataSource,
    });

    this.setState({ modalVisible: false });
  }

  handleModalCancel() {
    this.setState({ modalVisible: false });
  }

  render() {
    const { type, lowPrice, highPrice } = this.props;
    const { columns, dataSource, modalVisible } = this.state;

    const priceColumn = columns.find(item => item.dataIndex === 'price');
    if (!priceColumn) {
      const tempObj = {
        title: '价格（元）',
        dataIndex: 'price',
        width: 100,
        render: (text, record) => (
          <EditableCell
            value={text}
            onChange={this.onCellChange(record.key, 'price')}
            lowPrice={lowPrice}
            highPrice={highPrice}
          />
        ),
      };

      if (type === 'render') {
        delete tempObj.render;
      }

      columns.push(tempObj);
    }

    return (
      <div>
        {/* 标题 */}
        <p className={styles['set-price-title']}>
          <span className={styles['set-price-text']}>规格设置</span>
          {type === 'edit' ? (
            <Button
              type="primary"
              className={styles['set-price-btn']}
              onClick={this.handleSetPrice}
            >
              批量设置价格
            </Button>
          ) : null}
        </p>
        {/* 规格组合明细 */}
        <Table
          bordered
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          size="small"
          scroll={{ x: 500, y: 250 }}
        />
        {/* 价格设置对话框 */}
        <EditModal
          modalVisible={modalVisible}
          modalTitle="批量设置价格（人民币）"
          modalInputPlaceholder="请输入价格"
          inputValue=""
          onCancel={this.handleModalCancel}
          onOk={this.handleModalOk}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/SkusEdit/SkusTable/Index.js